import clsx from 'clsx';
import React from 'react';
import CoverTag from './CoverTag';
import DeleteButton from './DeleteButton';
import styles from './Video.module.scss';

interface VideoProps {
    src: string;
    isCover?: boolean;
    className?: string;
    onRemove?: () => void;
}

export const Video: React.FC<VideoProps> = props => {
    const [isLoading, setIsLoading] = React.useState(true);
    const [thumbnail, setThumbnail] = React.useState<string | undefined>(undefined);

    React.useEffect(() => {
        const video = document.createElement('video');
        video.muted = true;
        video.autoplay = true;
        video.playsInline = true;
        video.preload = 'metadata';
        video.crossOrigin = 'anonymous';
        video.src = props.src;

        const onLoadedData = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            if (!ctx) {
                setIsLoading(false);
                return;
            }

            try {
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;

                ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);

                const dataURL = canvas.toDataURL('image/png');
                setThumbnail(dataURL);
            } finally {
                setIsLoading(false);
            }
        };

        video.addEventListener('loadeddata', onLoadedData);
        video.load();

        return () => {
            video.removeEventListener('loadeddata', onLoadedData);
            video.src = '';
        };
    }, [props.src]);

    if (isLoading) {
        return <div className={clsx(styles.skeleton)} />;
    }

    return (
        <div className={clsx(styles.container, props.className)}>
            {thumbnail && (
                <img
                    src={thumbnail}
                    alt="Thumbnail"
                    className={styles.video}
                />
            )}

            {props.isCover && <CoverTag className={styles.cover} />}

            <DeleteButton
                className={styles.deleteButton}
                onClick={props.onRemove}
            />
        </div>
    );
};

export default Video;
